module.exports = __webpack_public_path__ + "static/media/logo-algolia.57c56ea4.png";